import { render, staticRenderFns } from "./IconPower.vue?vue&type=template&id=0298e083"
import script from "./IconPower.vue?vue&type=script&lang=js"
export * from "./IconPower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports